import { useCurrentUserId } from '@framework/auth';
import { UserIconMenu } from './UserIconMenu';
import { HeaderLoginButton } from './HeaderLoginButton';
import { NotificationIcon } from '@user/pages/ViewModelPage/FloatingUIContainer/HeaderMenuFirst/HeaderMenuRight/NotificationIcon';
import { useCallback, useState } from 'react';
import { NotificationList } from '@user/notification';
import { BannerAnnouncement } from '@user/notification/BannerAnnouncement';

type Props = {
  hideLoginButton?: boolean;
  children?: React.ReactNode;
};

export const TOP_NAVIGATION_HEIGHT = 64;

export const TopNavigation: React.FC<Props> = ({ hideLoginButton, children }: Props) => {
  const currentUserId = useCurrentUserId();

  const [showNotifications, setShowNotifications] = useState(false);
  const onToggleNotifications = useCallback(() => {
    setShowNotifications(!showNotifications);
  }, [showNotifications]);
  const onNotificationListClose = useCallback(() => setShowNotifications(false), []);

  return (
    <div
      className="flex w-full items-center justify-between border-b-2 bg-white"
      style={{ height: TOP_NAVIGATION_HEIGHT - 2 }}
    >
      <div className="flex items-center justify-start">
        <div className="z-0 flex items-center justify-start px-2">{children}</div>
      </div>
      <div className="flex items-center justify-end gap-x-4 p-2">
        {currentUserId ? (
          <>
            <div className="relative">
              <NotificationIcon
                className="pointer-events-auto"
                showNotifications={showNotifications}
                onToggle={onToggleNotifications}
                showButtonShadow={false}
              />
              {showNotifications && (
                <div className="absolute right-0 top-[80px] z-10">
                  <NotificationList onClose={onNotificationListClose} />
                </div>
              )}
            </div>
            <UserIconMenu userId={currentUserId} />
          </>
        ) : (
          !hideLoginButton && <HeaderLoginButton />
        )}
      </div>
      {!showNotifications && (
        <div className="pointer-events-none absolute left-0 top-0 flex size-full px-10 py-16">
          <BannerAnnouncement />
        </div>
      )}
    </div>
  );
};
